module.exports = __webpack_public_path__ + "static/media/bg-terrien@2x.ab526d3e.jpg";